import {COMPETITIONS_SLIDER_WIDGET} from "../competition-slider-widget.consts"
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {CompetitionsSliderTopDomainModel} from "../models/competitions-slider.top-domain-model";
import {CompetitionsSliderWidgetController} from "../competitions-slider-widget.controller";

export class CompetitionsSliderWidgetPopulateCompetitionsDataHandler extends PopulateDataHandler {
  controller: CompetitionsSliderWidgetController;
  type = COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.populateCompetitionsDataHandler;

  async action(params) {
    if (!params || !params.dataSource) {
      return;
    }

    const isSupportTopGames: Boolean = this.state.appState.settings.bootstrapSettings.supportTopGames || !this.state.device.isLargeView;

    this.state.competitionsDataSource = params.dataSource.competitions;

    if (isSupportTopGames) {
      const topGamesCompetition: CompetitionsSliderTopDomainModel = new CompetitionsSliderTopDomainModel({
        id: COMPETITIONS_SLIDER_WIDGET.DEFAULT_COMPETITION_TOP_GAMES_ID,
        name: this.state.terms.WEB_TOPGAMES_SEE_ALL_WIDGET
      })

      this.state.competitionsDataSource.push(topGamesCompetition)
    }

    await this.controller.action(COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.competitionChange, {id: this.state.competitions.first()?.id});


    return params;
  }
}
